import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import {BarcodeStatus} from '../../constants/dataEnum';

import './ErrorBarcodeModalContent.scss';

const PlateContainer = styled.div`
  width: 100%;
  height: 100%;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently*/
  display: grid;
  justify-content: center;
  align-content: center;
  text-align: center;
  grid-column-end: 3;
  grid-row-end: 2;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  margin-bottom: 15px;
`;

function PlateItem({barcode, name, status, isPlateClassification}) {
  const getBarcodeStatusLabel = (stat) => {
    switch (stat) {
      case BarcodeStatus.UNKNOWN:
        return <div className="plate-item-content-label label-red">Barcode Doesn&apos;t Match</div>;
      case BarcodeStatus.UNIDENTIFIED:
        return <div className="plate-item-content-label label-yellow">Barcode Not Found</div>;
      case BarcodeStatus.VALID:
      default:
        return <div className="plate-item-content-label label-green">Ready To Run</div>;
    }
  };

  const getBarcodeStatusIcon = (stat) => {
    switch (stat) {
      case BarcodeStatus.UNKNOWN:
        return './svg/barcode-scan/unknown-barcode.svg';
      case BarcodeStatus.UNIDENTIFIED:
        return './svg/barcode-scan/unidentified-barcode.svg';
      case BarcodeStatus.VALID:
      default:
        return './svg/barcode-scan/valid-barcode.svg';
    }
  };

  return (
    <div className="plate-item">
      <div className="plate-item-wrapper">
        <div className="plate-item-content">
          <div className="plate-item-content-icon">
            <img className="plate-item-content-icon-img" src={getBarcodeStatusIcon(status)} alt={status} />
          </div>
          {!isPlateClassification && getBarcodeStatusLabel(status)}
          <div className="plate-item-content-barcode">{barcode ?? name}</div>
        </div>
      </div>
    </div>
  );
}

PlateItem.propTypes = {
  barcode: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  isPlateClassification: PropTypes.bool,
};

PlateItem.defaultProps = {
  barcode: '',
  status: BarcodeStatus.VALID,
  name: '',
  isPlateClassification: false,
};

function PlateCaddy() {
  return (
    <div className="plate-item plate-caddy">
      <img className="plate-caddy-image" src="./svg/protocol-editor/tip-caddy.svg" alt="Caddy" />
    </div>
  );
}

function PlateEmpty({text}) {
  return (
    <div className="plate-item plate-empty">
      <div className="plate-item-wrapper">
        <div className="plate-item-content">
          <span>{text}</span>
        </div>
      </div>
    </div>
  );
}

PlateEmpty.propTypes = {
  text: PropTypes.string,
};

PlateEmpty.defaultProps = {
  text: '',
};

function ErrorBarcodeModalContent({barcodeLabware, isPlateClassification}) {
  return (
    <PlateContainer className="plate-suggestion-wrapper">
      {Object.keys(barcodeLabware).map((idx) => {
        if (idx === 2 || idx === '2') {
          return <PlateCaddy />;
        }

        if (!barcodeLabware[idx]?.status && !barcodeLabware[idx]?.barcode) {
          return <PlateEmpty text="Empty" />;
        }

        if (!barcodeLabware[idx]?.status && barcodeLabware[idx]?.barcode) {
          return <PlateEmpty text={barcodeLabware[idx]?.barcode} />;
        }

        return (
          <PlateItem
            barcode={barcodeLabware[idx]?.barcode}
            name={barcodeLabware[idx]?.name}
            status={barcodeLabware[idx]?.status}
            isPlateClassification={isPlateClassification}
          />
        );
      })}
    </PlateContainer>
  );
}

ErrorBarcodeModalContent.propTypes = {
  barcodeLabware: PropTypes.object,
  isPlateClassification: PropTypes.bool,
};

ErrorBarcodeModalContent.defaultProps = {
  barcodeLabware: {},
  isPlateClassification: false,
};

export default ErrorBarcodeModalContent;
